module.exports = __webpack_public_path__ + "static/media/Upload_Sample_w_COO.cf69cedb.csv";